import {useMutation} from 'react-query';
import patchUserPromotedAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IUsePatchUserPromotedAdvertisementProps {
  onSuccess?: () => void;
}
const usePatchUserPromotedAdvertisement = ({
  onSuccess,
}: IUsePatchUserPromotedAdvertisementProps) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (guid: string) => patchUserPromotedAdvertisement(guid),
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, PatchUserPromotedAdvertisementMutate: mutate};
};

export default usePatchUserPromotedAdvertisement;
